import { useReactiveVar } from '@apollo/client'
import { globalAlertData } from '../graphql/local'
import { AlertDataType } from '../types'

export const useAlert = () => {
  const alertData = useReactiveVar(globalAlertData)

  const setAlertData = (data: AlertDataType, delay?: number) => {
    globalAlertData(data)
    if (delay) {
      setTimeout(() => globalAlertData(null), delay)
    }
  }

  const resetAlertData = () => {
    globalAlertData(null)
  }

  return {
    alertData,
    setAlertData,
    resetAlertData,
  }
}
